import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  faCamera,
  faEnvelope,
  faLock,
  faMobileAlt,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { signUpUser } from "../../service/api.js";

function UserSignup() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState();
  const [password, setPassword] = useState("");
  const [image, setImage] = useState();
  const [bannerImage, setBannerImage] = useState();

  const navigate = useNavigate();
  const imageRef = useRef();
  const imageInputRef = useRef();
  const bannerRef = useRef();
  const bannerInputRef = useRef();

  const captureImage = (e) => {
    const url = URL.createObjectURL(e.target.files[0]);
    imageRef.current.src = url;
    setImage(e.target.files[0]);
  };
  const captureBanner = (e) => {
    const url = URL.createObjectURL(e.target.files[0]);
    bannerRef.current.src = url;
    setBannerImage(e.target.files[0]);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("password", password);
    formData.append("image", image);
    formData.append("banner", bannerImage);
    await signUpUser(formData);
    navigate("/user/login");
  };

  return (
    <div className="flex flex-col bg h-full min-h-screen justify-center items-center p-5">
      <h1 className="text-4xl font-bold m-3 text-white">Sign Up</h1>
      <form className="w-full flex flex-col gap-2.5 font-semibold md:w-3/5 lg:w-1/2">
        <div className="flex flex-col gap-2.5 items-center">
          <div
            className="cursor-pointer bg-slate-200 px-2 py-6 md:px-4 md:py-8 rounded-full flex flex-col items-center"
            onClick={() => {
              imageInputRef.current.click();
            }}
          >
            <FontAwesomeIcon icon={faCamera} size="lg" />
            <p className="text-xs">Upload Photo</p>
          </div>

          <input
            type="file"
            name=""
            id=""
            className="hidden"
            ref={imageInputRef}
            onChange={(e) => captureImage(e)}
          />
          <img
            src=""
            alt=""
            ref={imageRef}
            className="w-20 h-20 md:w-32 lg:w-40 md:h-32 lg:h-40 rounded-full"
          />
        </div>

        <div className="flex flex-col items-center gap-2.5">
          <div className="flex items-center justify-center w-full">
            <div
              className="rounded-full w-full text-center cursor-pointer bg-slate-300 py-3 mb-2"
              onClick={() => {
                bannerInputRef.current.click();
              }}
            >
              <h1>Tap to pick banner</h1>
            </div>
          </div>
          <input
            type="file"
            name=""
            id=""
            className="hidden"
            ref={bannerInputRef}
            onChange={(e) => captureBanner(e)}
          />
          <img
            src=""
            alt=""
            ref={bannerRef}
            className="w-full h-30 object-center object-cover rounded"
          />
        </div>

        <div className="flex flex-col gap-1">
          <label htmlFor="name" className="text-white">
            Name
          </label>
          <div className="rounded-lg flex items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-1.5 md:gap-4 bg-white text-xs md:text-base">
            <span>
              <FontAwesomeIcon icon={faUser} />
            </span>
            <input
              type="text"
              name="name"
              placeholder="Enter your Name"
              className="w-full h-full outline-none"
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="email" className="text-white">
            Email
          </label>
          <div className="rounded-lg flex items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-1.5 md:gap-4 bg-white text-xs md:text-base">
            <span className="">
              <FontAwesomeIcon icon={faEnvelope} />
            </span>
            <input
              type="email"
              name="email"
              placeholder="Enter your Email"
              className="w-full h-full outline-none"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="password" className="text-white">
            Password
          </label>
          <div className="rounded-lg flex items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-1.5 md:gap-4 bg-white text-xs md:text-base">
            <span className="">
              <FontAwesomeIcon icon={faLock} />
            </span>
            <input
              type="password"
              name="password"
              placeholder="Enter your Password"
              className="w-full h-full outline-none"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <label htmlFor="phone" className="text-white">
            Phone no.
          </label>
          <div className="rounded-lg flex items-center border-2 px-2 py-1.5 md:px-4 md:py-3 gap-1.5 md:gap-4 bg-white text-xs md:text-base">
            <span>
              <FontAwesomeIcon icon={faMobileAlt} />
            </span>
            <input
              type="number"
              name="phone"
              placeholder="Enter your Phone no."
              className="w-full h-full outline-none"
              onChange={(e) => {
                setPhone(e.target.value);
              }}
            />
          </div>
        </div>

        <div className="flex justify-center items-center mt-5">
          <button
            className="rounded-full text-center w-full px-4 py-1.5 bg-white text-cyan-700 font-bold"
            onClick={(e) => onSubmit(e)}
          >
            SIGN UP
          </button>
        </div>
      </form>

      <div className="w-full mt-3 text-xs text-center md:text-base text-white">
        <p>
          Already have an Account?{" "}
          <Link to="/user" className="font-bold">
            Sign In
          </Link>
        </p>
      </div>
    </div>
  );
}

export default UserSignup;
